module.exports = __webpack_public_path__ + "static/media/embrace.1cd630fb.png";